module.exports = __webpack_public_path__ + "img/sn.4362aabd.svg";